var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconApply1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "62px",
    height: "62px",
    viewBox: "0 0 62 62",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 18") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.8,
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "remark/5.0-\\u6211\\u8981\\u7533\\u8ACB",
    transform: "translate(-482.000000, -265.000000)",
    stroke: "#CAB5A0",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(365.000000, 138.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(63.000000, 128.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-18",
    transform: "translate(55.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-1",
    strokeLinecap: "square",
    points: "20.3225806 57.0967742 60 57.0967742 60 60"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-3",
    strokeLinecap: "square",
    points: "0 60 0 57.0967742 11.6129032 57.0967742"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-6",
    strokeLinecap: "square",
    points: "3.87096774 55.1612903 3.87096774 51.2903226 56.1290323 51.2903226 56.1290323 55.1612903"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.516129,26.1290323 C14.516129,26.1290323 15.5719355,33.3164516 15.5719355,37.7419355 C15.5719355,42.1712903 14.516129,47.4193548 14.516129,47.4193548",
    id: "Stroke-7",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4516129,24.1935484 C16.4516129,25.2619355 15.5845161,26.1290323 14.516129,26.1290323 L13.5483871,26.1290323",
    id: "Stroke-9",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4516129,49.3548387 C16.4516129,48.2864516 15.5845161,47.4193548 14.516129,47.4193548 L13.5483871,47.4193548",
    id: "Stroke-11",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.77419355,50.3225806 L6.77419355,49.3548387 C6.77419355,48.2864516 7.64129032,47.4193548 8.70967742,47.4193548 C8.70967742,47.4193548 7.65387097,42.1712903 7.65387097,37.7419355 C7.65387097,33.3164516 8.70967742,26.1290323 8.70967742,26.1290323 C7.64129032,26.1290323 6.77419355,25.2619355 6.77419355,24.1935484 L6.77419355,23.2258065",
    id: "Stroke-13",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2903226,26.1290323 C51.2903226,26.1290323 52.346129,33.3164516 52.346129,37.7419355 C52.346129,42.1712903 51.2903226,47.4193548 51.2903226,47.4193548",
    id: "Stroke-15",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2258065,24.1935484 C53.2258065,25.2619355 52.3587097,26.1290323 51.2903226,26.1290323 L50.3225806,26.1290323",
    id: "Stroke-17",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2258065,49.3548387 C53.2258065,48.2864516 52.3587097,47.4193548 51.2903226,47.4193548 L50.3225806,47.4193548",
    id: "Stroke-19",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5483871,50.3225806 L43.5483871,49.3548387 C43.5483871,48.2864516 44.4154839,47.4193548 45.483871,47.4193548 C45.483871,47.4193548 44.4280645,42.1712903 44.4280645,37.7419355 C44.4280645,33.3164516 45.483871,26.1290323 45.483871,26.1290323 C44.4154839,26.1290323 43.5483871,25.2619355 43.5483871,24.1935484 L43.5483871,23.2258065",
    id: "Stroke-21",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-23",
    strokeLinecap: "square",
    points: "57.0967742 16.4516129 57.0967742 22.2580645 2.90322581 22.2580645 2.90322581 16.4516129 30 0"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-25",
    strokeLinecap: "square",
    points: "22.2580645 50.3225806 22.2580645 28.0645161 37.7419355 28.0645161 37.7419355 50.3225806"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0967742,42.0967742 C27.8225806,43.5483871 29.2741935,43.5483871 29.2741935,43.5483871 L30.8467742,43.5483871 C31.9112903,43.5483871 32.7822581,42.6774194 32.7822581,41.6129032 C32.7822581,40.5483871 31.9112903,39.6774194 30.8467742,39.6774194 L29.1532258,39.6774194 C28.0887097,39.6774194 27.2177419,38.8064516 27.2177419,37.7419355 C27.2177419,36.6774194 28.0887097,35.8064516 29.1532258,35.8064516 L30.7258065,35.8064516 C30.7258065,35.8064516 32.1774194,35.8064516 32.9032258,37.2580645",
    id: "Stroke-27",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30,33.8709677 L30,35.8064516",
    id: "Stroke-29",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30,43.5483871 L30,45.483871",
    id: "Stroke-31",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9032258,9.67741935 C32.9032258,11.2809677 31.6035484,12.5806452 30,12.5806452 C28.3964516,12.5806452 27.0967742,11.2809677 27.0967742,9.67741935 C27.0967742,8.07387097 28.3964516,6.77419355 30,6.77419355 C31.6035484,6.77419355 32.9032258,8.07387097 32.9032258,9.67741935 Z",
    id: "Stroke-33",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.67741935,17.4193548 L50.3225806,17.4193548",
    id: "Stroke-35",
    strokeLinecap: "round"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconApply1);
export default __webpack_public_path__ + "static/media/icon-apply1.86e0e83dadc93288eb3c2047d6f846a0.svg";
export { ForwardRef as ReactComponent };